// Barra de la plataforma nueva SÓLO en móvil (< 768 px): botón del cajón del menú, isotipo, idioma y tema.
// En escritorio no hay barra superior: el botón para contraer el menú va junto al logo (MenuLateral.jsx) y el idioma
// y el tema van en el encabezado de cada página, a la altura del título (comun/PaginaModulo.jsx).
// CONTRATO: botón «Abrir menú» / «Cerrar menú» con aria-expanded y aria-controls="menu-modulos".
import { forwardRef } from 'react';
import { Menu as IconoMenu } from 'lucide-react';
import { IconButton } from '../../ds/components/core/Button';
import { DbLogo } from '../../ds/brand/DbLogo';
import { useDbTheme } from '../../ds/theme/ThemeProvider';
import ControlesGlobales from './ControlesGlobales';

const Encabezado = forwardRef(function Encabezado({ abierto, onMenu }, ref) {
  const { theme } = useDbTheme();
  return (
    <header className="flex h-14 shrink-0 items-center gap-2 px-3">
      <IconButton
        ref={ref}
        icon={IconoMenu}
        label={abierto ? 'Cerrar menú' : 'Abrir menú'}
        variant="ghost"
        size="sm"
        aria-expanded={abierto}
        aria-controls="menu-modulos"
        onClick={onMenu}
      />
      <span className="flex-1">
        <DbLogo variant={theme === 'dark' ? 'mono' : 'color'} lockup="iso" className="h-7 w-auto text-ink" />
      </span>
      <ControlesGlobales />
    </header>
  );
});

export default Encabezado;
